import { ICartRowItem } from "./types/ICartRowItem";

export class CartItem implements ICartRowItem {
    UoMPrice?: number;
    QtyOrderedEACH?: number;
    PriceExtension?: number;
    OrderItemRecNo: number;
    CartOrderID: number;
    ItemID: string;
    QtyOrdered: number;
    UoMDesc: string;
    UoMPackSize: number;
    UnitPrice: number;
    UoM: string;
    QuantityOrdered: KnockoutObservable<number>;    
    FinalPrice: KnockoutComputed<number>;
    Description: string;
    ListPrice: number;
    ImageUrl: string;
    ProductUrl: string;
    PercDiscount: number;
    ItemGroupRecNo: number;
    Heading: string;
    RxProduct: string;
    Rx?: string;
    VendName: string;
    VendItemNo: string;
    AvaleraTaxCode: string;
    Status: string;
    AlertType: string;
    ALERTStatus: string;
    ALERTOrgDate: string;
    ALERTUpdateDate: string;
    ALERTExpStatus: string;
    INFOEstShipDate: string;
    ImgSrc: string;    
    AltItemList?: Array<any>;    
}